import React from "react";
import { PayPalButton } from "react-paypal-button-v2";
import { Payment } from "./Payment";

interface IProps {
	onPaymentSuccess: (payment: Payment) => void;
	onPaymentError: (error: any) => void;
	amount: number;
	type: string;
}

export const PayPalPayment = (props: IProps) => {
	return (
		<PayPalButton
			amount={props.amount}
			options={{
				clientId:
					"AVk-6ZjX6X0hVeB1tqw3dS7ZrwQyaCnoL7GCwx54DcWidns7Hhxr15Ip3GrWsmpav_jAiEQAwRR3Bhrq",
			}}
			onSuccess={(details: any) => {
				if (details.status === "COMPLETED") {
					const pmt = new Payment({
						type: props.type,
						method: "PayPal",
						amount: details.purchase_units[0].amount.value,
						currency:
							details.purchase_units[0].amount.currency_code,
						processorData: JSON.stringify(details),
					});

					props.onPaymentSuccess(pmt);
				}
			}}
			catchError={(error: any) => {
				props.onPaymentError(error);
			}}
			onError={(error: any) => {
				props.onPaymentError(error);
			}}
		/>
	);
};
